import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import {Footer} from "../../shared";
import Navbar from "../homepage/Navbar";
import FlipkartIcon from "../../assets/image/png/flipkart icon.jpg"; // Import the image
import { useDispatch, useSelector } from "react-redux";
import { handleLoginPopup } from "../../redux/slice/userSlice";
import { useNavigate } from "react-router-dom"; // For navigation
import { Header } from "../../shared";

const Wcart = ({ cartItems = [], onLogin }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showLogin } = useSelector((state) => state.user);
  const isLogin = false; // Placeholder for login state (Cookies.get('token') can be used in real implementation)

  const handleLoginClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top smoothly
    navigate("/"); // Redirect to the home page (or any page)
    dispatch(handleLoginPopup(true)); // Open the login popup/modal
  };

  return (
    <>
      <div className="cart-container bg-light_gray">
        <Header />
        <Container className="mt-4">
          <Row>
            <Col md={12}>
              <h2 className="ff_heebo fw-bold fs_43 clr_dark_blue_2">
                My Cart
              </h2>
              <div className="text-center mt-5">
                <img
                  src={FlipkartIcon}
                  alt="Flipkart Icon"
                  style={{ width: "250px", height: "200px" }}
                />{" "}
                {/* Adjust size if needed */}
              </div>
              <div className="login-prompt text-center mb-5">
                <h2>Missing Cart Items?</h2>
                <p>Login to see the items you added previously</p>
                <Button variant="primary" onClick={handleLoginClick}>
                  Log In
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Wcart;
